import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { PUBLIC_PATHS } from '../constants.ts';

// Your existing logic
export const platoAdminPaths = ['/admin*'];

const isPublic = (path: string): boolean => {
    const sanitizedPath = path.split('#')[0]?.split('?')[0];
    return PUBLIC_PATHS.some((x) => sanitizedPath?.match(new RegExp(`^${x.replace('*$', '($|/)')}`)));
};

const isPlatoAdmin = (path: string): boolean => {
    return platoAdminPaths.some((x) => new RegExp(`^${x}$`.replace('*$', '($|/)')).exec(path));
};

const isRedirect = (path: string): boolean => {
    return path === '/redirect';
};

// Updated usePublicOrPrivateRoute hook
const useRouteType = () => {
    const { pathname } = useLocation();

    const isPublicRoute = useMemo(() => isPublic(pathname), [pathname]);
    const isSuperAdminRoute = useMemo(() => isPlatoAdmin(pathname), [pathname]);
    const isRedirectRoute = useMemo(() => isRedirect(pathname), [pathname]);

    return {
        isPublicRoute, // true if it's a public route, false otherwise
        isSuperAdminRoute, // true if it's a Plato Admin route, false otherwise
        isRedirectRoute, // true if it's a redirect route, false otherwise
        isPlatUserRoute: !isPublicRoute, // true if it's a private route, false otherwise
    };
};

export default useRouteType;
